import React, {Component} from 'react';

import './loading.css';

class Loading extends Component {
  constructor(props){
    super(props);
    this.state = { dot: '', count: 0 };  
    
      setInterval(() => {
        if(this.state.count > 2) {
          this.setState({ dot: '', count: 0});
        } else {
          this.setState({dot: this.state.dot + '.', count: this.state.count + 1});
        }
      }, 1000);
    
  }

  render() {
    return (
      <div className={ this.props.active ? 'backdrop' : 'backdrop finished'}>
        <img className="d-block m-auto loading-img pb-1" width="40" src="/assets/images/drumsloading.png" alt="loading icon" />
        <p className="text-center text-primary">Aguardando Winvites.io{this.state.dot}</p>
      </div>
    );
  }

}


export default Loading;


// WEBPACK FOOTER //
// ./src/components/Loading/index.js